import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, headers: { "Content-Type": "application/json" } });

export const getHealth = () => api.get("/health").then((r) => r.data);
export const getKatlasStatus = () => api.get("/katlas/status").then((r) => r.data);
export const getDossier = () => api.get("/teardown/dossier").then((r) => r.data);
export const approveReview = () => api.post("/teardown/review/approve").then((r) => r.data);
export const refuseReview = () => api.post("/teardown/review/refuse").then((r) => r.data);
export const getReceipt = (hash, isPublic = false) =>
  api.get(`/teardown/receipts/${hash}`, { params: { public: isPublic } }).then((r) => r.data);
